import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Special event countdown block',
  name: 'specialEventCountdown',
  type: 'object',
  fields: [
    defineField({
      title: 'Theme',
      name: 'theme',
      type: 'string',
      options: {
        list: [
          { title: 'Default (dark bg, white text)', value: 'default' },
          { title: 'Light (white bg, dark texts)', value: 'light' },
        ],
      },
      initialValue: 'default',
      description: 'Background & text colors.',
    }),
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
    }),
    defineField({
      title: 'Content',
      name: 'content',
      type: 'text',
    }),
    defineField({
      title: 'Desktop BG',
      name: 'bgDesktop',
      type: 'image',
      options: {
        hotspot: true,
      },
    }),
    defineField({
      title: 'Mobile BG',
      name: 'bgMobile',
      type: 'image',
      options: {
        hotspot: true,
      },
    }),
  ],
  preview: {
    select: {
      title: 'title',
      media: 'bgDesktop',
    },
    prepare({ title, media }) {
      return {
        title: title || 'Special Event Countdown',
        media,
        subtitle: 'Special Event Countdown',
      }
    },
  },
})
